export function handleScrollIntoViewAnimation() {
    const animatedElements = document.querySelectorAll('main > div:not(.pul-header):not(.pul-breadcrumbs):not(.pul-text-block)');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('in-view');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0,
        rootMargin: '0px 0px -100px 0px'
    });

    animatedElements.forEach(element => {
        observer.observe(element);
    });
}